module.exports = "<wow-content-setting setting-group=\"SiteContent\" setting-name=\"FooterContent1\"></wow-content-setting>\r\n\r\n<section class=\"footer\">\r\n\t<div class=\"container\">\r\n\t\t<wow-content-setting ng-if=\"!breakpointsService.isInSmallFormat\" setting-group=\"SiteContent\" setting-name=\"FooterContent2\"></wow-content-setting>\r\n\t\t<wow-content-setting ng-if=\"breakpointsService.isInSmallFormat\" setting-group=\"SiteContent\" setting-name=\"FooterMobileContent\"></wow-content-setting>\r\n\t</div>\r\n</section>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/footer/footer-template.html
 ** module id = 943
 ** module chunks = 1
 **/